import Vue from 'vue'
import axios from 'axios'
import store from './store'
var eventBus = new Vue();
var cacheObj = {};

export default {
	cfg: {
		title:"引力盒子",
		api: "http://www.choicemedia.cn/a/index.php",//'/api',
		domain:'http://www.choicemedia.cn',
		reg: {
			phone: /^13[0-9]{9}$|14[0-9]{9}$|15[0-9]{9}$|166[0-9]{8}$|17[0-9]{9}$|18[0-9]{9}$|19[89][0-9]{8}$/,
			email: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
			smsCode: /^\d{6}$/,
			// emjFilter:/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDE80-\uDEFF]/g
		},
		server: {

		},
		canWebp: function () {
			var cvs = document.createElement('canvas');
			return cvs.getContext && cvs.toDataURL('image/webp').indexOf('data:image/webp') === 0;
		}()
	},
	isIos(){
		var ua = window.navigator.userAgent;
		return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && ua.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'
	},
	event: eventBus,
	store: store,
	cache: {
		get: function (key) {
			return key in cacheObj ? cacheObj[key] : null;
		},
		set: function (key, val) {
			cacheObj[key] = val;
		},
	},
	loadingStack: {},
	axios: axios,
	initWxShare(payload){
		var self = this;
		this.ajax({
			op:'m=App&c=News&a=share',
			send:{
				url:self.isIos()?window.landingPageUrl:window.location.href
			},
			callback(data){
				if(data.status==1){
					wx.config({
						debug: false, 
						appId: data.data.appid, 
						timestamp:data.data.timestamp, 
						nonceStr: data.data.noncestr,
						signature: data.data.signature,
						jsApiList:['onMenuShareTimeline','onMenuShareAppMessage']
					});
					wx.ready(function(){
						payload.callback();
					})
				}
			}
		})
	},
	getloginData(cb){
		this.ajax({
			op:"m=App&c=User&a=my_info",
			send:{},
			callback(data){
				cb&&cb(data);
			}
		})
	},
	rem_init(fixed) {
		var fontSize = 10;
		if((window.screen.width/window.screen.height>0.72)&&window.screen.width>=768){
			fontSize = 16;
		}
		else{
			fontSize = window.screen.width / 320 * 10;
		}
		// if (!fixed || typeof fixed == 'undefined') {
		// 	fontSize = window.screen.width / 320 * 10 < 24 ? window.screen.width / 320 * 10 : 24;
		// }
		document.getElementsByTagName("html")[0].style.fontSize = fontSize + "px";
		window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function () {
			clearTimeout(window.resizePage)
			window.resizePage = setTimeout(function () {
				if((window.screen.width/window.screen.height>0.72) && window.screen.width>=768){
					fontSize = 16;
				}
				else{
					fontSize = window.screen.width / 320 * 10;
				}
				// if (!fixed || typeof fixed == 'undefined') {
				// 	fontSize = window.screen.width / 320 * 10 < 24 ? window.screen.width / 320 * 10 : 24;
				// }
				document.getElementsByTagName("html")[0].style.fontSize = fontSize + "px";
			}, 50)
		}, false);
		//开发环境显示手机浏览器控制台
		// if (process.env.NODE_ENV === "development") {
		//   (function () {
		//     var script = document.createElement('script');
		//     script.src = "http://eruda.liriliri.io/eruda.min.js";
		//     document.body.appendChild(script);
		//     script.onload = function () {
		//       eruda.init();
		//       eruda.get('console').config.set('overrideConsole', false);
		//     }
		//   })();
		// }
	},
	cancelAjax: null,
	param(obj) {
		var r = '';
		Object.keys(obj).forEach((item, index) => {
			r += (item + "=" + obj[item] + "&");
		})
		r = r.slice(0, -1);
		return r;
	},
	fmtTime(timestamp){
		var now = new Date();
		var stamp = new Date(timestamp*1000);
		if(now.getFullYear()==stamp.getFullYear()&&now.getMonth()==stamp.getMonth()&&Math.abs(now.getDate()-stamp.getDate()<2)){
			if(Math.abs(now.getDate()-stamp.getDate()<1)){
				return Math.round(now.getHours()-stamp.getHours())+"小时前";
			}
			return "昨天";
		}
		else if(now.getFullYear()==stamp.getFullYear()){
			return (stamp.getMonth()+1)+'月'+stamp.getDate()+'日';
		}
		else{
			return stamp.getFullYear()+'年'+(stamp.getMonth()+1)+'月';
		}
	},
	pad0(n){
		return +n<10?"0"+n:n;
	},
	htmlDecode(text) { 
		var temp = document.createElement("div"); 
		temp.innerHTML = text; 
		var output = temp.innerText || temp.textContent; 
		temp = null; 
		return output; 
	},
	//公用ajax
	ajax(obj) {
		var _self = this;
		var _cacheData = null;
		_self.cancelAjax = axios.CancelToken.source();
		var _config = {
			timeout: 20000,
		};
		if (!obj.noCancel) {
			_config['cancelToken'] = _self.cancelAjax.token;
		}
		var loading_st = null;
		if (!(obj.url || obj.op)) {
			console.warn("ajax参数未传递！")
			return false
		}
		if (obj.way == 'get' || !obj.way) {
			//组件scope缓存
			// if (obj.dataScope && typeof obj.dataScope[obj.url] !== 'undefined') {
			// 	obj.callback && obj.callback(obj.dataScope[obj.url])
			// }
			//全局变量缓存
			var _url = obj.url || _self.cfg.api+"?"+obj.op;
			if (obj.cacheWay == "state" && _self.cache.get(_url) != null) {
				var _state = _self.cache.get(_url)
				obj.callback && obj.callback(_state)
			}
			//store本地缓存
			else if (obj.cacheWay == "store" && _self.store.get(_url, obj.storeTime)) {
				var _store = _self.store.get(_url);
				obj.callback && obj.callback(_store)
			}
			else {
				if (typeof obj.noLoading === 'undefined' || !obj.noLoading) {
					loading_st = setTimeout(() => {
						_self.event.$emit('loadingShow', true)
					}, 500)
					_self.loadingStack[loading_st] = true
				}
				axios({
					method: 'post',
					url: _url,
					headers:{
						'Content-Type':'application/x-www-form-urlencoded'
					},
					data: obj.send,
					transformRequest: [function (data) {
						let ret = ''
						for (let it in data) {
							ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
						}
						return ret.slice(0,-1);
						}],
				  }).then(response => {
					//清除延时loading					
					!obj.noLoading && _self.clearLoading(loading_st);
					if (response.data.status == "1") {
						if (obj.dataScope) {
							obj.dataScope[_url] = response.data
						}
						else if (obj.cacheWay == "state") {
							_self.cache.set(_url, response.data)
						}
						else if (obj.cacheWay == "store") {
							_self.store.set(_url, response.data)

						}
					}
					obj.callback && obj.callback(response.data)
				}, response => {
					obj.errback && obj.errback(response.data);
					//清除延时loading					
					!obj.noLoading && _self.clearLoading(loading_st);
					if (axios.isCancel(response)) {
						return false;//手动终止请求不提示错误
					}
					else {
						obj.error && obj.error(response.data)
						_self.tip("网络异常")
					}
				})
			}
		}
	},
	//函数节流
	funCtrl(fn, delay, mustRunDelay, timer) {
		var timer = null,
			t_start;
		return function () {
			var context = this,
				args = arguments,
				t_curr = +new Date();
			clearTimeout(timer);
			if (!t_start) {
				t_start = t_curr;
			}
			if (t_curr - t_start >= mustRunDelay) {
				fn.apply(context, args);
				t_start = t_curr;
			} else {
				timer = setTimeout(function () {
					fn.apply(context, args);
				}, delay);
			}
		}
	},
	urlSearchObj() {
		var url = "" + (arguments[0] || window.location.search),
			_url;
		if (url.indexOf("?") !== 0) {
			return {};
		}
		_url = decodeURI(url.slice(1));
		var _s = _url.split("&");
		var d = {};
		for (var i = 0; i < _s.length; i++) {
			var _v = _s[i].split("=");
			if (_v[0] === 'id' && _v[1].indexOf('!') !== -1) {
				d[_v[0]] = _v[1].slice(0, -1);
			} else {
				d[_v[0]] = _v[1];
			}
		}
		return d;
	},
	clearLoading(st_code) {
		var _self = this;
		clearTimeout(st_code)
		_self.loadingStack[st_code] = false;
		var canClear = false;
		for (var i in _self.loadingStack) {
			canClear = canClear || _self.loadingStack[i]
		}
		if (canClear == false) {
			_self.event.$emit('loadingShow', false)
		}
	},
	//公用提示
	tip(payload) {
		this.event.$emit('tip', payload)
	},
	isEmptyObject(obj) {
		for (var n in obj) {
			return false
		}
		return true;
	},
	rds: function (n) {
		var _rs = 'ABCDEFGHIthisLMNOPQRSTUVWXYZabcdefghithislmnopqrstuvwxyz1234567890';
		var r = '';
		for (let i = 0; i < n; i++) {
			r += _rs[parseInt(Math.random() * (_rs.length - 1))];
		}
		return r;
	},
	string: {
		compileStr: function (code) {
			var c = String.fromCharCode(code.charCodeAt(0) + code.length);
			for (var i = 1; i < code.length; i++) {
				c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
			}
			return escape(c);
		},
		uncompileStr: function (code) {
			code = unescape(code);
			var c = String.fromCharCode(code.charCodeAt(0) - code.length);
			for (var i = 1; i < code.length; i++) {
				c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
			}
			return c;
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js